import {gql} from 'apollo-angular';

export const SEND_GAME_JR_ANSWER = gql`
  query SendGameJrAnswer($entryId: Int!, $requirementId: Int!) {
    sendGameJRAnswer(gameJRSchoolClassEntryID: $entryId, requirementID: $requirementId) {
      isCorrect
      isComplete
      answerHeadline
      requirements {
        id
        bicID
        requirementName
        description
      }
    }
  }
`;
